

<template>
  <HeaderContent title="Room"/>
  <ActionContent ctaText="Add Room" @action="modal = !modal" :filterDate="false"/>
  <RoomStatistics title="Room Statistics" :data="statistics" />
  <RoomForm :modal="modal" @update:modal="modal = $event"/>
  <RoomFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event"/>
  <RoomConfirm title="Confirmation" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
    <template #text>Are you sure to delete this data ?</template>
  </RoomConfirm>
  <RoomDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>
<script>

import { ref } from 'vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import RoomForm from "./RoomForm.vue";
import RoomFilter from "./RoomFilter.vue";
import RoomStatistics from '@/components/StatisticData.vue';
import RoomConfirm from '@/components/ModalDialog.vue';
import RoomDataTable from '@/components/DataTable.vue';
import iconAvailable from "../../../public/icons/octagon-check.svg";
import iconCheckout from "../../../public/icons/building-circle-arrow-right.svg";
import iconCheckIn from "../../../public/icons/check-in-calendar.svg";
import iconReserved from "../../../public/icons/reservation-table.svg";
import iconDirty from "../../../public/icons/sweep.svg";
import iconInhouse from "../../../public/icons/person-shelter.svg";
import iconIncleaning from "../../../public/icons/sparkles.svg";
import iconUnderMaintenance from "../../../public/icons/wrench-simple.svg";
import iconDeluxe from '../../../public/icons/business-value.svg';
import iconSuperDeluxe from '../../../public/icons/diamond.svg';
import iconStudio from '../../../public/icons/space-station-moon.svg';
import iconHoneymoon from '../../../public/icons/rings-wedding.svg';
import iconFamily from '../../../public/icons/family-pants.svg';

export default {
  components: {
    HeaderContent,
    ActionContent,
    RoomForm,
    RoomFilter,
    RoomConfirm,
    RoomStatistics,
    RoomDataTable,
  },
  setup(){
    const modal = ref(false)
    const modalFilter = ref(false)
    const modalConfirm = ref(false)
    
    const showModal = () => {
      modal.value = true
    }
    const editItem = (item) => {
      console.log("Editing:", item);
    }
    const deleteItem = (item) => {
      console.log("Editing:", item);
    }
    const data = ref([
      { 
        no: 1, 
        type_room: 'Deluxe', 
        normal_price: 800000,
        high_season: 800000,
        room_number: 'A3', 
        discount: '10%', 
        status_room: {
          key: 'available',
          label: 'Available',
          icon: iconAvailable,  
        },
      },
      { 
        no: 1, 
        type_room: 'Super Deluxe', 
        normal_price: 900000,
        high_season: 990000,
        room_number: 'A2', 
        discount: '5%', 
        status_room: {
          key: 'reserved',
          label: 'Reserved',
          icon: iconReserved,  
        },
      },
      { 
        no: 1, 
        type_room: 'Studio', 
        normal_price: 900000,
        high_season: 990000,
        room_number: 'A5', 
        discount: '5%', 
        status_room: {
          key: 'in_cleaning',
          label: 'In Cleaning',
          icon: iconIncleaning,  
        },
      },
      { 
        no: 1, 
        type_room: 'Family', 
        normal_price: 900000,
        high_season: 990000,
        room_number: 'A1', 
        discount: '5%', 
        status_room: {
          key: 'under_maintenance',
          label: 'Under Maintenance',
          icon: iconUnderMaintenance,  
        },
      },
      { 
        no: 1, 
        type_room: 'Family', 
        normal_price: 900000,
        high_season: 990000,
        room_number: 'A2', 
        discount: '5%', 
        status_room: {
          key: 'inhouse',
          label: 'In House',
          icon: iconInhouse,  
        },
      },
      { 
        no: 1, 
        type_room: 'Family', 
        normal_price: 900000,
        high_season: 990000,
        room_number: 'A3', 
        discount: '5%', 
        status_room: {
          key: 'checkout',
          label: 'Check Out',
          icon: iconCheckout,  
        },
      },
      { 
        no: 1, 
        type_room: 'Family', 
        normal_price: 900000,
        high_season: 990000,
        room_number: 'A4', 
        discount: '5%', 
        status_room: {
          key: 'dirty',
          label: 'Dirty',
          icon: iconDirty,  
        },
      },
      { 
        no: 1, 
        type_room: 'Honeymoon', 
        normal_price: 900000,
        high_season: 990000,
        room_number: 'A1', 
        discount: '5%', 
        status_room: {
          key: 'checkin',
          label: 'Check In',
          icon: iconCheckIn,  
        },
      }
    ]);
    const headers = ref([
      {
        key: 'type_room',
        label: 'Type Room',
        sortable: true,
      },
      {
        key: 'room_number',
        label: 'Room Number',
        sortable: true,
      },
      {
        key: 'normal_price',
        label: 'Normal Price',
        sortable: true,
      },
      {
        key: 'high_season',
        label: 'High Season',
        sortable: true,
      },
      {
        key: 'discount',
        label: 'Diskon',
        sortable: true,
      },
      {
        key: 'status_room',
        label: 'Status Room',
        sortable: true,
      },
      {
        key: 'action',
        label: 'Actions',
      }
    ])
    
    const customActions = ref([
      {
          label: 'Edit',
          variant: 'success',
          icon: 'fas fa-edit',
          action: (item) => {
          console.log('Edit action clicked for:', item);
          // Implement your Edit logic here
          }
      },
      {
          label: 'Delete',
          variant: 'danger',
          icon: 'fas fa-trash',
          action: (item) => {
          console.log('Delete action clicked for:', item);
          // Implement your Delete logic here
          }
      },
    ])

    const statistics = ref([
      {
        label: 'Total',
        key: 'Deluxe',
        value: 3,
        color: 'danger',
        icon: iconDeluxe,
      },
      {
        label: 'Total',
        key: 'Super Deluxe',
        value: 3,
        color: 'light',
        icon: iconSuperDeluxe,
      },
      {
        label: 'Total',
        key: 'Studio',
        value: 3,
        color: 'success',
        icon: iconStudio,
      },
      {
        label: 'Total',
        key: 'Honeymoon',
        value: 3,
        color: 'primary',
        icon: iconHoneymoon,
      },
      {
        label: 'Total',
        key: 'Family',
        value: 3,
        color: 'orange',
        icon: iconFamily,
      },
    ])

    return{
      showModal,
      editItem,
      deleteItem,
      data,
      headers,
      modal,
      modalFilter,
      modalConfirm,
      customActions,
      statistics,
    }
  }


}
</script>


<style>

</style>